import React from 'react';
import Router from './Router';
import { WalletProvider } from './wallet-context';
import PinataProvider from './hooks/pinata/Provider';
import BrainProvider from './hooks/brain/Provider';

const App: React.FC = () => {
  return (
    <WalletProvider>
      <PinataProvider>
        <BrainProvider>
          <Router />
        </BrainProvider>
      </PinataProvider>
    </WalletProvider>
  );
};

export default App;
